import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import styles from './Chart.module.css';

const Chart = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [activeDatasets, setActiveDatasets] = useState({
    current: true,
    previous: true
  });

  // Sample data for the chart
  const data = [
    { date: 'Dec1', current: 123, previous: 70 },
    { date: 'Dec5', current: 150, previous: 60 },
    { date: 'Dec10', current: 2300, previous: 3123 },
    { date: 'Dec11', current: 15000, previous: 13123 },
    { date: 'Dec12', current: 123, previous: 3123 },
  ];

  // Toggle dataset visibility
  const toggleDataset = (dataset) => {
    setActiveDatasets(prev => ({
      ...prev,
      [dataset]: !prev[dataset]
    }));
  };

  const CustomTooltip = ({ active = false, payload = [] }) => {
    if (active && payload && payload.length) {
      return (
        <div className={styles.tooltip}>
          <div className={styles.tooltipTitle}>Net Profit Over Time</div>
          <div className={styles.tooltipContent}>
            <div className={styles.tooltipRow}>
              <span className={styles.tooltipLabel}>Current</span>
              <span className={styles.tooltipValue}>${payload[0]?.value || 0}</span>
            </div>
            <div className={styles.tooltipRow}>
              <span className={styles.tooltipLabel}>Previous:</span>
              <span className={`${styles.tooltipValueHighlighted}`}>${payload[1]?.value || '0'}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Net Profit Over time</h3>
        <div className={styles.buttonGroup}>
          <button 
            onClick={() => toggleDataset('current')}
            className={`${styles.button} ${activeDatasets.current ? styles.buttonActive : styles.buttonInactive}`}
          >
            <span className={`${styles.colorIndicator} ${styles.currentColor}`}></span>
            Current
          </button>
          <button 
            onClick={() => toggleDataset('previous')}
            className={`${styles.button} ${activeDatasets.previous ? styles.buttonActive : styles.buttonInactive}`}
          >
            <span className={`${styles.colorIndicator} ${styles.previousColor}`}></span>
            Previous
          </button>
        </div>
      </div>

      <div className={styles.chartContainer}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
            margin={{ top: 20, right: 20, left: 40, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#f0f0f0" />
            <XAxis 
              dataKey="date" 
              axisLine={false} 
              tickLine={false}
              tick={{ fill: 'var(--static-text-weak)' }}
              // Removed padding to align properly
              tickMargin={10}
              className={styles.chartXAxis}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fill: 'var(--static-text-weak)' }}
              ticks={[0, 5000, 10000, 15000, 20000]}
              tickFormatter={(value) => value === 0 ? '0' : `${value / 1000}k`}
              tickMargin={10}
              dx={-10}
              orientation="left"
              width={40}
            />
            <Tooltip 
              content={<CustomTooltip />} 
              cursor={{ stroke: '#f0f0f0', strokeWidth: 1 }}
            />
            {activeDatasets.current && (
              <Line 
                type="monotone" 
                dataKey="current" 
                stroke="#ef4444" 
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 6, fill: '#ef4444', stroke: 'white', strokeWidth: 2 }}
              />
            )}
            {activeDatasets.previous && (
              <Line 
                type="monotone" 
                dataKey="previous" 
                stroke="#1f2937" 
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 6, fill: '#1f2937', stroke: 'white', strokeWidth: 2 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;